import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table relation user aggregator view.
 * @extends JetView
 */
export default class tableRelationUserAggregatorView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // ID for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scroll: 'xy', // Enable scrolling in both directions
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Editar', // Tooltip text
                                    template: function (obj) {
                                        // Template function for rendering
                                        if (devConfig.getPermAction('relationUserAggregatorEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon if permission granted
                                        } else {
                                            return ''; // No icon if permission denied
                                        }
                                    },
                                },
                                {
                                    id: 'UserPartner', // Column ID for User Partner
                                    header: _('Usuario Partner'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserAggregator', // Column ID for User Aggregator
                                    header: _('Usuario Aggregator'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CreatedLocalDate', // Column ID for Created Local Date
                                    header: _('Fecha de Creación'), // Localized column header
                                    fillspace: 0, // Fill space setting
                                    minWidth: 0, // Minimum width
                                    width: 150, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    // Event handler for edit button click
                                    $$('Edit').show(); // Show edit popup
                                },
                            },
                            ready: function () {
                                // Event handler for when the DataTable is ready
                                if (!this.count()) {
                                    // Check if there are no data items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data message
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead setting
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch setting
                            pager: 'pagerA', // ID for the pager component
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Reference to the DataTable instance
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'es/RelationUserAggregator/GetRelationUserAggregator'; // API endpoint for fetching data
        var filter = ''; // Filter string for API requests

        // Event listener for filtering data
        this.on(this.app, 'relationUserAggregator:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object and non-empty values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom2=' + date[0]; // Add start date to filter string
                        string1 = string1 + '&dateTo2=' + date[1]; // Add end date to filter string
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add filter to string
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date filter
                                var date = object[i][1].replace(' 00:00:00', ''); // Remove time from date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter string
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
            $$('filterPopup').hide(); // Hide filter popup
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data based on selected player ID
            );
        });

        // Create formatted date for CreatedLocalDate
        var createdLocalDate =
            webix.Date.add(new Date(), -1, 'day').getFullYear() +
            ':' +
            ('00' + (webix.Date.add(new Date(), -1, 'day').getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -1, 'day').getDate()).slice(-2);

        // Create edit popup window
        var popup = webix.ui({
            view: 'window',
            id: 'Edit', // ID for the edit popup
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Editar Relación') }, // Label for the edit window
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on close
                        },
                    },
                ],
            },
            position: 'center', // Center position for the popup
            modal: true, // Modal window
            body: {
                view: 'form', // Form inside the popup
                id: 'editForm', // ID for the edit form
                elements: [
                    {
                        view: 'text',
                        label: _('Usuario Partner'), // Localized label
                        labelWidth: 140, // Label width
                        name: 'UserPartner', // Form field name
                    },
                    {
                        view: 'text',
                        label: _('Usuario Aggregator'), // Localized label
                        labelWidth: 140, // Label width
                        name: 'UserAggregator', // Form field name
                    },
                    {
                        view: 'text',
                        label: _('Fecha de Creación'), // Localized label
                        labelWidth: 140, // Label width
                        name: 'CreatedLocalDate', // Form field name
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button label
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the popup on cancel
                                    $$('editForm').setValues(
                                        $$('editForm').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Save button label
                                click: function ($e) {
                                    var values = $$('editForm').getValues(); // Get form values
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type for AJAX request
                                        })
                                        .post(
                                            devConfig.geturlApi() +
                                                'RelationUserAggregator/UpdateRelationUserAggregator',
                                            '{"UserPartner":"' +
                                                values.UserPartner +
                                                '", "UserAggregator":"' +
                                                values.UserAggregator +
                                                '", "CreatedLocalDate":"' +
                                                createdLocalDate +
                                                '"}', // Send updated data
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        _('Actualizado'), // Show success message
                                                    );
                                                    grid.clearAll(); // Clear grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                    );
                                                },
                                            },
                                        );
                                    $$('editForm').setValues(
                                        $$('editForm').getCleanValues(), // Reset form values
                                    );
                                    this.getTopParentView().hide(); // Hide the popup
                                },
                            },
                        ],
                    },
                ],
            },
        });

        // Create add popup window
        var popupAdd = webix.ui({
            view: 'window',
            id: 'Add', // ID for the add popup
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on close
                        },
                    },
                ],
            },
            position: 'center', // Center position for the popup
            modal: true, // Modal window
            body: {
                view: 'form', // Form inside the popup
                id: 'addform', // ID for the add form
                elements: [
                    {
                        view: 'text',
                        label: _('Usuario Partner'), // Localized label
                        labelWidth: 140, // Label width
                        name: 'UserPartner', // Form field name
                    },
                    {
                        view: 'text',
                        label: _('Usuario Aggregator'), // Localized label
                        labelWidth: 140, // Label width
                        name: 'UserAggregator', // Form field name
                    },
                    {
                        view: 'text',
                        label: _('Fecha de Creación'), // Localized label
                        labelWidth: 140, // Label width
                        name: 'CreatedLocalDate', // Form field name
                        value: createdLocalDate, // Set default value
                        readonly: true, // Make field read-only
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button label
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the popup on cancel
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Save button label
                                click: function ($e) {
                                    var values = $$('addform').getValues(); // Get form values
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type for AJAX request
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'RelationUserAggregator/AddRelationUserAggregator',
                                            '{"UserPartner":"' +
                                                values.UserPartner +
                                                '", "UserAggregator":"' +
                                                values.UserAggregator +
                                                '", "CreatedLocalDate":"' +
                                                values.CreatedLocalDate +
                                                '"}', // Send new data
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        _('Agregado'), // Show success message
                                                    );
                                                    grid.clearAll(); // Clear grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                    );
                                                },
                                            },
                                        );
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                    this.getTopParentView().hide(); // Hide the popup
                                },
                            },
                        ],
                    },
                ],
            },
        });

        // Event listener for showing add relation user aggregator popup
        this.on(this.app, 'addRelationUserAggregator:button', (filter) => {
            popupAdd.show(); // Show add popup
        });

        $$('editForm').bind($$('datatable')); // Bind edit form to the DataTable
    }
}

// FILE DOCUMENTED
